import { BaseService } from '@flint/framework';

export default class UserList extends BaseService {
  constructor() {
    super("FETCHING_USER_LIST", 'UserListStore', true);
  }

  handleEvent(eventName) {
    return this.getClient('vetService').get(`/admin-api/users/`);
  }
}